import {Evento, FTA} from './../model/catalogo';
import {constructDependencies} from '@angular/core/src/di/reflective_provider';
import {JQueryStatic} from 'jquery';

declare var $: JQueryStatic;

export class ValidacaoService {

    constructor() {
    }

    listaMensagem = [];
    contador = 0;

    validaFta(fta: FTA): boolean {
        let msg = '<b>Existem campos obrigatórios não preenchidos</b>. <br>';
        var valida = true;

        if (fta.nome == null || fta.nome.length == 0) {
            msg = msg + '<span>' + "Campo 'Nome' obrigatório." + '</span><br>';
            valida = false;
        }

        if (fta.descricao == null || fta.descricao.length == 0) {
            msg = msg + '<span>' + "Campo 'Descrição' obrigatório." + '</span><br>';
            valida = false;
        }

        if (!valida) {
            $.confirm({
                title: 'Atenção!',
                content: msg,
                type: 'red',
                buttons: {
                    ok: {
                        btnClass: 'btn-blue'
                    }
                },
                onClose: () => {
                }
            });
        }

        return valida;
    }

    validaEvento(evento: Evento): boolean {
        this.recuperaMensagens(evento);
        if (this.listaMensagem.length > 0) {
            let msg = '<b>Existem campos obrigatórios não preenchidos</b>. <br>';
            for (let i in this.listaMensagem) {
                msg = msg + '<span>' + this.listaMensagem[i] + '</span><br>';
            }

            $.confirm({
                title: 'Atenção!',
                content: msg,
                type: 'red',
                buttons: {
                    ok: {
                        btnClass: 'btn-blue'
                    }
                },
                onClose: () => {

                }
            });

            return false;

        } else {
            return true;
        }
    }

    recuperaMensagens(evento: Evento): Array<string> {

        this.listaMensagem = [];

        if (evento.subfluxoVinculado.length == 0) {
            this.listaMensagem.push('Informe a vinculação de subfluxo na aba \'Evento\'');
        }

        //validacao evento anterior
        if (evento.codTipoTrigger == 4 && evento.dependencia.length == 0) {
            this.listaMensagem.push('Informe a vinculação de evento anterior na aba \'Dependência\'');
        }

        //validacao evento
        if (evento.descricao == null || evento.descricao == undefined || evento.descricao.length == 0) {
            this.listaMensagem.push('Informe a Descrição na aba \'Evento\'');
        }

        //validacao evento
        if (evento.codTipoTrigger == null || evento.codTipoTrigger == undefined) {
            this.listaMensagem.push('Selecione o trigger na aba \'Evento\'');
        }

        if (evento.grupo.length == 0) {
            this.listaMensagem.push('Informe a vinculação de grupo na aba \'Evento\'');
        }

        //validacao evento
        if (evento.codTipoEvento == null || evento.codTipoEvento == undefined) {
            this.listaMensagem.push('Informe um tipo de Evento na aba \'Evento\'');
        }
        if (evento.codTipoTrigger == null || evento.codTipoTrigger == undefined) {
            this.listaMensagem.push('Informe um tipo de Trigger na aba \'Evento\'');
        }
        if (evento.codTipoEvento == null || evento.codTipoPeriodicidade == undefined) {
            this.listaMensagem.push('Informe um tipo de Periodicidade na aba \'Evento\'');
        }

        //validacao Operacao
        if (evento.codTipoEvento == 2 &&
            evento.detalheEventoOperacao.parmOperacao.length == 0) {
            this.listaMensagem.push('Informe os parâmetros na aba \'Operação\'');
        }
        if (evento.codTipoEvento == 3 &&
            evento.detalheEventoProcessamento.clienteResponsavelProcessamento == null) {
            this.listaMensagem.push('Informe os parâmetros do evento Processamento\'');
        }


        //validacao Transmissao
        if (evento.codTipoEvento == 1 && (evento.detalheEventoTransmissao.nomeItemConfiguracaoProduto == null || evento.detalheEventoTransmissao.nomeItemConfiguracaoProduto == undefined)) {
            this.listaMensagem.push('Informe o nome item configuração do produto na aba \'Transmissão\'');
        }


        //validacao Transmissao
        if (evento.codTipoEvento == 1 && evento.detalheEventoTransmissao.origem.length == 0) {
            this.listaMensagem.push('Informe o Cliente Origem na aba \'Transmissão\'');
        }

        if (evento.codTipoEvento == 1 && evento.detalheEventoTransmissao.destino.length == 0) {
            this.listaMensagem.push('Informe o Cliente Destino na aba \'Transmissão\'');
        }

        if (Array.isArray(evento.listaParametrosSelecionados)) {
            evento.listaParametrosSelecionados.map((parametroSelecionados) => {
                this.contador = 0;

                if (parametroSelecionados.selecionado == true) {
                    parametroSelecionados.parmConteudo.reduce((parmConteudoKey, parmConteudoDados) => {
                        if (parmConteudoDados.selecionado && parametroSelecionados.nomeTipoDado != 'boolean' && (parametroSelecionados.nomeSubtipoDado == 'sel_excl' || parametroSelecionados.nomeSubtipoDado == 'sel_mult')) {
                            this.contador++;
                        }
                    }, '');


                    if (parametroSelecionados.nomeTipoDado != 'boolean' && (parametroSelecionados.nomeSubtipoDado == 'sel_excl' || parametroSelecionados.nomeSubtipoDado == 'sel_mult')) {
                        if (this.contador == 0) {
                            this.listaMensagem.push('Informe os Parâmetro(s) obrigatorio(s) na aba \'Transmissão\'');
                        }
                    } else {
                        if (parametroSelecionados.parmConteudo[0] && parametroSelecionados.nomeTipoDado != 'boolean') {
                            if (!parametroSelecionados.parmConteudo[0].conteudo) {
                                this.listaMensagem.push('Informe os Parâmetro(s) obrigatorio(s) na aba \'Transmissão\'');
                            } else if (parametroSelecionados.parmConteudo[0].conteudo != 'true' && parametroSelecionados.parmConteudo[0].conteudo != 'false' && parametroSelecionados.nomeTipoDado == 'boolean') {
                                this.listaMensagem.push('Informe os Parâmetro(s) obrigatorio(s) na aba \'Transmissão\'');
                            }
                        }
                    }

                }
            });
        }

        if (Array.isArray(evento.listaParametrosSelecionadosOperacao)) {
            evento.listaParametrosSelecionadosOperacao.map((parametroSelecionadosOperacao) => {
                this.contador = 0;

                if (parametroSelecionadosOperacao.selecionado == true) {
                    parametroSelecionadosOperacao.parmConteudo.reduce((parmConteudoKey, parmConteudoDados) => {
                        if (parmConteudoDados.selecionado && parametroSelecionadosOperacao.nomeTipoDado != 'boolean' && (parametroSelecionadosOperacao.nomeSubtipoDado == 'sel_excl' || parametroSelecionadosOperacao.nomeSubtipoDado == 'sel_mult')) {
                            this.contador++;
                        }
                    }, '');

                    if (parametroSelecionadosOperacao.nomeTipoDado != 'boolean' && (parametroSelecionadosOperacao.nomeSubtipoDado == 'sel_excl' || parametroSelecionadosOperacao.nomeSubtipoDado == 'sel_mult')) {
                        if (this.contador == 0) {
                            this.listaMensagem.push('Informe os Parâmetro(s) obrigatorio(s) na aba \'Operação\' 1');
                        }
                    } else {
                        if (parametroSelecionadosOperacao.parmConteudo[0]) {
                            if (!parametroSelecionadosOperacao.parmConteudo[0].conteudo && parametroSelecionadosOperacao.nomeTipoDado != 'boolean') {
                                this.listaMensagem.push('Informe os Parâmetro(s) obrigatorio(s) na aba \'Operação\' 2');
                            } else if (parametroSelecionadosOperacao.parmConteudo[0].conteudo != 'true' && parametroSelecionadosOperacao.parmConteudo[0].conteudo != 'false' && parametroSelecionadosOperacao.nomeTipoDado == 'boolean') {
                                this.listaMensagem.push('Informe os Parâmetro(s) obrigatorio(s) na aba \'Operação\' 3');
                            }
                        }
                    }

                }
            });
        }

        return this.listaMensagem;
    }


}



// WEBPACK FOOTER //
// ./src/service/validacao.service.ts